import React from 'react';
import Loading from '@bit/knotchinc.web-react-components.loading';
import { CenteredPageContainer } from '@bit/knotchinc.web-react-components.page';

const LoadingPage = () => (
  <CenteredPageContainer>
    <Loading />
  </CenteredPageContainer>);

export default LoadingPage;
